<div class="center-box">
    <div class="center-box-container">
        <app-authorization *ngIf="ready" [changeUrl]="changeUrl" [email]="email" [role]="role"
                           [redirect]="'/'" [registrationOnly]="!!email"></app-authorization>
    </div>
</div>
